<template>
  <div>
    <div class="header-wrapper">
      <div class="header">推送历史</div>
    </div>
    <history-card :historyList="historyList"></history-card>
    <infinite-loading :identifier="newRule" @infinite="loadMore">
      <div slot="no-more"></div>
      <div slot="no-results">没有该分类数据</div>
    </infinite-loading>
  </div>
</template>
<script>
  var that
  import historyCard from './components/historyCard'
  export default {
    components: {
      historyCard
   },
    data () {
      return {
        historyList: [],
        page: 1,
        rows: 20,
        newRule:0
      }
    },
    methods:{
      loadMore($state) {
        this.getHistory($state);
      },
      getHistory ($state) {
        console.log($state)
        var url = that.urlobj.getsendList()+'?sendType=send'
        that.$store.commit("updateSpinShow", true);
        that.$post(url,{
          pageNum: that.page,
          pageSize: that.rows
        }).then(res => {
          that.$store.commit("updateSpinShow", false);
          if (res.rows.length) {
            that.page ++
            $state.loaded(); // 结束加载状态
            var historyList = res.rows.map(item => {
              return {
                coverPicUrl:item.coverPicUrl,
                title:item.title,
                sendDate:item.sendDate.replace(/\.0/g,''),
                receiveNumber:item.receiveNumber,
                sendType:item.sendType
              }
            })
            that.historyList = that.historyList.concat(historyList)
          }else {
            /* 如果没有数据 完成加载 */
            $state.complete();
          }
        })
      }
    },
    mounted () {
      that = this

    }
  }
</script>

<style scoped>
  .header-wrapper {
    display: flex;
    /*height: 30px;*/
    height:85px;
    line-height:85px;
    justify-content:center;
    text-align: center;
    position: relative;
    color:#656565
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
</style>
